export default __webpack_public_path__ + "c52f89a15d1bd24aaa8ca2290354d60d.png";